import React, { ReactElement } from 'react';

import ContractLayout from 'pricing/components/contract/contractLayout/ContractLayout';
import ContractCreateContent from 'pricing/pages/contractCreate/contractCreateContent/ContractCreateContent';

function ContractEdit(): ReactElement {
  return (
    <ContractLayout>
      <ContractCreateContent />
    </ContractLayout>
  );
}

export default ContractEdit;
